import { Files } from '@components/Files/Files'
import { useAppDispatch } from '@hooks/redux'
import { RoutePaths } from '@interfaces/routePaths'
import {
  clearBreadcrumbs,
  setActionsButton,
  setActiveSection,
  setInviteButton,
} from '@redux/site/siteSlice'
import { useEffect } from 'react'

export const Base = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Files'))
    dispatch(clearBreadcrumbs())
    dispatch(setInviteButton(false))
    dispatch(setActionsButton(false))
  })

  return (
    <Files
      fullWidth
      state={{
        history: [
          {
            title: 'Files',
            href: RoutePaths.FILES,
          },
        ],
      }}
    />
  )
}
